import React from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import icEmpty from 'assets/svg/ic_empty.svg';

const EmptyListV2 = ({
  className,
  title = 'Sorry, no result found.'
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className)
  }, /*#__PURE__*/React.createElement("img", {
    draggable: false,
    className: styles.img,
    src: icEmpty
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, title));
};

export default EmptyListV2;